// Only metadata from an enabled native profile can introduce additional seats.
// This does not add a new engine or a selectable GBA link mode.
export function playerSeats(game) {
  const advertised = game?.profile?.controllers;
  const count = Number.isInteger(advertised) && advertised >= 1 && advertised <= 4 ? advertised : 2;
  return Array.from({ length: count }, (_, index) => index + 1);
}
export function seatDescription(game) {
  const names = playerSeats(game).map(seat => 'P' + seat);
  return names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + ' or ' + names[names.length - 1];
}
// Assignment count is separate from the enabled emulator's controller capacity.
// Do not renumber occupied seats: each number selects a real console/input port.
export function controllerAssignments(room) {
  const supported = playerSeats(room?.game);
  const capacity = Number.isInteger(room?.controllerLimit) && room.controllerLimit >= 1 && room.controllerLimit <= 4
    ? Math.min(room.controllerLimit, supported.length) : supported.length;
  const seats = supported.slice(0, capacity), members = room?.members || [];
  const occupied = seats.filter(seat => members.some(member => member.seat === seat));
  const nextSeat = seats.find(seat => !occupied.includes(seat)) ?? null;
  return { count: occupied.length, capacity, visibleSeats: occupied.length ? occupied : [seats[0]],
    nextSeat, availableMembers: members.filter(member => !seats.includes(member.seat)) };
}
export function personalScreenAspect(game) {
  if (game?.mode === 'linked' && ['gb', 'gbc'].includes(game.system)) return '10 / 9';
  return game?.profile?.aspect || (['gb', 'gbc'].includes(game?.system) ? '10 / 9' : game?.system === 'gba' ? '3 / 2' : '4 / 3');
}
